import { QuickSearchPage } from 'src/views/clog/cia'
import pathMap from 'src/paths/pathMap'

class TradeWizardRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.CALISTA_ADVISORY_WIZARD,
        component: QuickSearchPage
      }
    ]
  }
}

export default TradeWizardRoute
